
import { defineComponent, ref } from 'vue';
import recordVue from '@/components/report/record.vue';
import scoreVue from '@/components/report/score.vue';
import userInfoVue from '@/components/report/userInfo.vue';
import backHeaderVue from '@/components/ui/backHeader/index.vue';
import { Uuid } from '@/lib/index';
import useReportHooks, { Component } from '@/hooks/report.hooks';
import { useRoute, useRouter } from 'vue-router';
import print from 'vue3-print-nb';
import { Button } from 'ant-design-vue';

export default defineComponent({
  directives: {
    print,
  },
  components: {
    recordVue,
    scoreVue,
    userInfoVue,
    backHeaderVue,
    aButton: Button,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const reportHooks = useReportHooks();
    const componentList = ref<Uuid<Component>[]>([]);
    const printObj = {
      id: 'm-body',
      popTitle: '实验报告',
    };

    const init = async () => {
      const comData = await reportHooks.getExperimentReport(route.params.id as string);
      componentList.value = reportHooks.setComponentData(reportHooks.getReportComponents(), comData);
    };

    init();
    const back = () => {
      router.back();
    };
    return {
      componentList,
      back,
      printObj,
    };
  },
});
